<template>
  <div class="mx-3" :key="refreshKey" :style="isShareSession ? 'padding-top:75px;padding-left:10px':'' ">
    <div class="row mx-2">
      <div class="col-md-6" style="padding-left: 0 !important">
        <h4 class="font-weight-bold pb-2 d-flex" style="align-items:center;gap:6px"><font-awesome-icon v-if="!isShareSession" @click="goBack()" icon="long-arrow-alt-left" class="btn-third p-1 cursor-pointer mr-2" style="border-radius:50%;width: 30px;height: 30px;" />{{ pollName }}</h4>
        <!-- <AirbnbDatePicker
          class="cursor-pointer d-inline-block align-top float-left"
          module="poll"
        ></AirbnbDatePicker> -->
      </div>
      <div class="col-md-6 mb-2" style="padding-left: 0 !important">
        <div class="float-right">
          <button v-if="!isShareSession && isAdminRole && $isHowuku" class="btn btn-muted" @click="openShareLinkSettings() ">
                  <font-awesome-icon v-if="!isPublicShare" icon="lock" class="mr-1"></font-awesome-icon>  
                  <font-awesome-icon v-else icon="link" class="mr-1"></font-awesome-icon>  
                  <span>Share Link</span>
          </button>
          <AirbnbDatePicker
            v-if="$isOptimize"
            module="dashboard"
            class="mb-auto d-inline-block mr-2"
            ref="datePicker"
          ></AirbnbDatePicker>              
        </div>
      </div>
      <div class="col-md-4 py-3 pl-0 ml-0" style="min-height: 100vh;padding-top: 1.2rem !important;">
        <span class="font-weight-bold mb-3">{{ t('Show Results For') }}:</span>
        <select v-model="selected" class="form-control custom-select">
          <option
            v-for="(item, key) in data.poll"
            v-bind:key="key"
            :value="item.poll_id"
          >
            {{ item.poll_question }}
          </option>
        </select>
        <div
          class="mt-4"
          v-for="(item, key) in data.poll"
          v-bind:key="key"
          :id="item.poll_question"
          v-show="selected === item.poll_id"
        >
          <!-- <h5 class="font-weight-bold" style="line-height: 1.5;">{{ item.poll_question }}</h5> -->
          <template v-if="isNps">
            <div v-if="nps.total" class="progress progress-square">
              <div
                v-bind:class="{ 'progress-bar-success': showNps.promoter }"
                class="progress-bar progress-bar-success-fade"
                role="progressbar"
                :style="'width:' + nps.promoter + '%'"
              >
                {{ Math.round(nps.promoter, 0) }}%
              </div>
              <div
                v-bind:class="{ 'progress-bar-warning': showNps.passive }"
                class="progress-bar progress-bar-warning-fade"
                role="progressbar"
                :style="'width:' + nps.passive + '%'"
              >
                {{ Math.round(nps.passive, 0) }}%
              </div>
              <div
                v-bind:class="{ 'progress-bar-danger': showNps.detractor }"
                class="progress-bar progress-bar-danger-fade"
                role="progressbar"
                :style="'width:' + nps.detractor + '%'"
              >
                {{ Math.round(nps.detractor, 0) }}%
              </div>
            </div>
            <p class="pt-3">
              <b>NPS Score:</b>
              {{ nps.score }}
            </p>

            <h5 class="font-weight-bold mb-3 mt-4 pt-4">Filter</h5>
            <span class="font-weight-bold text-muted2" v-translate
              >Responses</span
            >
            <div class="row mt-3">
              <div class="col-md-12">
                Promoters
                <toggle-button
                  class="float-right"
                  v-model="showNps.promoter"
                  :sync="true"
                  color="#2eb15a"
                  :labels="true"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                Passives
                <toggle-button
                  class="float-right"
                  v-model="showNps.passive"
                  :sync="true"
                  color="#2eb15a"
                  :labels="true"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                Detractors
                <toggle-button
                  class="float-right"
                  v-model="showNps.detractor"
                  :sync="true"
                  color="#2eb15a"
                  :labels="true"
                />
              </div>
            </div>
          </template>
          <template v-if="item.poll_option_openend && !isNps">
            <span v-if="filterByText !== ''">
              Filter by:
              <b>{{ filterByText }}</b>
              <small
                class="cursor-pointer text-primary"
                @click="filterByText = ''"
                >clear filter</small
              >
            </span>
            <wordcloud
              :data="defaultWords"
              nameKey="name"
              valueKey="value"
              :color="myColors"
              :showTooltip="false"
              :wordClick="wordClickHandler"
              :fontSize="[20, 100]"
            ></wordcloud>
          </template>
          <template v-if="!item.poll_option_openend && !isNps">
            <div
              class="row mb-1"
              v-for="(answer, index) in data.answer"
              v-bind:key="index"
            >
              <div class="col-md-10 mb-1">
                <div
                  class="poll-background position-relative"
                  :style="
                    'width:' +
                    calculatePercent(
                      pollAnswerCounter[answer.id],
                      data.comment.length
                    ) *
                      0.95 +
                    '% !important'
                  "
                >
                  <div class="p-2">
                    <span class>{{ answer.text }}</span>
                  </div>
                </div>
              </div>
              <div class="col p-2 text-right">
                <span class="text-right">
                  {{ pollAnswerCounter[answer.id] }}
                  <br>
                  <span class="text-muted small">
                  {{
                    calculatePercent(
                      pollAnswerCounter[answer.id],
                      data.comment.length
                    )
                  }}%</span></span>
              </div>
            </div>
            <div class="row" v-if="item.poll_option_other">
              <div class="col-md-10 mb-1">
                <div
                  class="poll-background position-relative"
                  :style="
                    'width:' +
                    calculatePercent(pollAnswerCounter[0], data.comment.length) *
                      0.95 +
                    '% !important'
                  "
                >
                  <div class="p-2">
                    <span class>{{ item.other_text || 'Other' }}</span>
                  </div>
                </div>
              </div>
              <div class="col p-2">
                <span class="text-right"
                  >{{
                    calculatePercent(pollAnswerCounter[0], data.comment.length)
                  }}%</span
                >
              </div>
            </div>

            <h5 class="font-weight-bold mb-3 mt-4 pt-4">Filter</h5>
            <span class="font-weight-bold text-muted2">Comments</span>
            <div class="row mt-3" v-if="!item.poll_option_nps">
              <div class="col-md-12">
                With comments
                <toggle-button
                  class="float-right"
                  v-model="showOtherOnly"
                  :sync="true"
                  color="#2eb15a"
                  :labels="true"
                />
              </div>
            </div>
          </template>

          <div class="row mt-2">
            <div class="col-md-12">
              <p>Export data</p>
              <div
                v-if="
                  ($isFreePlan.includes($session.get('paid_plan')) ||
                  $isLegacyFreePlan.includes($session.get('paid_plan'))) && !isShareSession
                "
                class="upgrade-badge"
                style="top: 6px; float: left; margin-left: 135px"
              ></div>
              <div
                v-if="
                  ($isFreePlan.includes($session.get('paid_plan')) ||
                  $isLegacyFreePlan.includes($session.get('paid_plan'))) && !isShareSession
                "
                class="upgrade-badge"
                style="top: 6px; float: left; margin-left: 296px"
              ></div>
              <button v-if="$isHowuku || $isOptimize" class="btn btn-first" @click="summarize() ">
                <font-awesome-icon icon="magic" class="mr-1"></font-awesome-icon>  
                <span>Summarize Survey</span>
              </button>                        
              <span
                @click="(!isShareSession)?exportCsv():''"
                class="pt-1 small cursor-pointer btn btn-outline-muted"
              >
                <font-awesome-icon icon="download" class="mr-2" />
                Export to CSV</span>

       
              <!-- <span
                @click="(!isShareSession)?downloadPdf():''"
                class="pt-1 small cursor-pointer btn btn-outline-muted"
              >
                <font-awesome-icon icon="download" class="mr-2" />
                Download PDF</span
              > -->
            </div>
          </div>
        </div>
      </div>

      <!-- Right Panel -->
      <div class="col-md-8">
        <div
          class="col-md-12 p-4 listing scrollable"
          style="height: 100vh"
          v-if="!isLoaded"
        >
          <div class="row">
            <div class="col-md-8">
              <span class="font-weight-bold" v-translate>Responses</span>
              <br />
              <p class="text-muted2">0 over 0 has responded</p>
            </div>
            <div class="col ml-auto text-right mr-2">
              <span>
                <!-- <font-awesome-icon class="fa-lg" @click="$modal.hide('show-responses')" icon="times" /> -->
              </span>
            </div>
          </div>
          <div
            class="col-sm-12 col-md-12 col-xl-10 card-hover"
            v-show="!isLoaded"
            v-for="n in 3"
            v-bind:key="n"
          >
            <div class="comment-row col">
              <content-placeholders>
                <content-placeholders-heading :img="true" />
              </content-placeholders>
            </div>
          </div>
        </div>
        <div class="col-md-12 listing scrollable" style="height: 100vh" v-else>
          <div class="row">
            <div class="col-md-8">
              <span class="font-weight-bold" v-translate>Responses</span>
              <br />
              <p class="text-muted2">
                {{ data.comment.length }}
                <!-- over {{ data.impression }}  -->
                responses
              </p>
            </div>
            <div class="col ml-auto text-right mr-2">
              <span>
                <!-- <font-awesome-icon class="fa-lg" @click="$modal.hide('show-responses')" icon="times" /> -->
              </span>
            </div>
          </div>
          <div v-if="data.comment.length" :key="detailKey">
            <div
              class="comment-row col"
              v-for="(item, key) in data.comment"
              v-bind:key="key"
              v-show="
                (!showOtherOnly || (showOtherOnly && checkifOther(item))) &&
                (!isNps || (isNps && checkifNps(item))) &&
                (filterByText === '' || findMatchingKeyword(item.comment_body))
              "
              :data-title="
                concealOldPost(item.submit_at)
                  ? `Get unlimited polling history - upgrade your account to BASIC plan to recover this polling`
                  : null
              "
            >
              <div
                class="row"
                v-blur="{
                  isBlurred: concealOldPost(item.submit_at),
                  opacity: 1,
                  filter: 'blur(5px)',
                  transition: 'all .3s linear',
                }"
              >
                <div
                  class="col-md-12"
                  v-bind:class="{
                    blockInteraction: concealOldPost(item.submit_at),
                  }"
                >
                  <span
                    class="cursor-pointer"
                    v-bind:class="{
                      'text-muted small': !(item.name || item.email || item.uuid),
                    }"
                    @click="(!isShareSession)?showProfile(item.visitor_id):''"
                  >
                    <p class="d-inline-block mb-0 a-link" v-if="item.name && item.name !== 'Anonymous'">
                      {{ shorten(item.name, 40) }}
                    </p>
                    <p
                      class="d-inline-block mb-0 a-link"
                      v-else-if="item.email"
                    >
                      {{ shorten(item.email, 40) }}
                    </p>
                    <p class="d-inline-block mb-0 a-link" v-else>
                      Visitor {{ shorten_last(item.uuid, 8) }}
                    </p>
                  </span>
                  <p class="font-weight-500 mt-1 mb-2">
                    <span
                      class="text-first font-weight-bold"
                      v-if="!isOpenendQuestion && inAnswerList(item.answer)"
                      >{{ item.other_text || 'Other' }}&nbsp;</span
                    >
                    <span
                      class="font-weight-bold"
                      v-bind:class="{
                        'text-first': !isNps,
                        'h2 text-success': isNps & (Number(item.answer) >= 9),
                        'h2 text-warning':
                          isNps & (Number(item.answer) === 7) ||
                          Number(item.answer) === 8,
                        'h2 text-danger': isNps & (Number(item.answer) <= 6),
                      }"
                      v-else-if="
                        item.comment_body !== item.answer &&
                        item.comment_body !== ''
                      "
                    >
                      <template v-if="item.poll_option_nps"></template>
                      {{ item.answer }}
                    </span>
                    <span style="white-space: pre-wrap">{{
                      item.comment_body !== item.answer &&
                      item.comment_body !== ''
                        ? item.comment_body
                        : item.answer
                    }}</span>
                  </p>
                  <span class="text-muted2 font-weight-500 fs-12"
                    >{{ timeSince(item.submit_at) }} ·
                    {{ item.destination }}</span
                  >
                </div>
                <div class="col ml-auto text-right">
                  <!-- <IpDeviceInfo :device="item.device" :os="item.os" :browser="item.browser" size="18px"/> -->
                </div>
              </div>
            </div>
          </div>
          <div v-if="!data.comment.length && allData.comment.length">
            <div class="col-md-6 text-center mx-auto">
              <img
                  width="100"
                  class="d-block mx-auto"
                  src="@/assets/img/no-record.png"
                />
              <br />
              <h5>
                <span v-translate>No record found.</span>
                <span v-translate>Try selecting a wider range of dates to see more results.</span>
              </h5>
            </div>
          </div>
          <div v-if="!data.comment.length && !allData.comment.length">
            <div class="col-md-6 text-center mx-auto">
              <h5>
                <img
                  width="100"
                  class="d-block mx-auto"
                  src="../assets/img/no-record.png"
                />
                <br />
                <span v-translate>No record found.</span>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="slide-right">
      <modal style="z-index: 10000;" class="to-right full-modal" name="show-survey-summary" width="500px" height="100%" :adaptive="true">
        <h6 class="font-weight-600 fs-12 text-uppercase" style="padding: 20px 20px 10px;color: rgba(100, 116, 139, 1);border-top: 1px solid rgba(241, 245, 249, 1);">
          {{ t('Howuku AI Summary') }}
        </h6>
        <div class="text-center px-4 py-4" v-if="summaryLoading"><font-awesome-icon icon="circle-notch" class="fa-spin text-muted fa-sm"/> Please hold, while we are doing some AI magic..</div>      
        <div class="pr-4" v-if="summary && summary!== ''">
          <vue-markdown class="mx-4 md-preview">{{ summary }}</vue-markdown>
        </div>
      </modal>
    </transition>
    <modal
      name="show-profile"
      :adaptive="true"
      height="100%"
      width="100%"
      class="full-modal"
      style="z-index: 10000 !important"
      @before-open="modalOnOpen"
      @before-close="getData()"
    >
      <VisitorProfile :visitor_id="visitor_id"></VisitorProfile>
    </modal>
    <transition name="slide-right">
      <modal style="z-index: 10000" class="to-right full-modal" name="show-shareSettings" width="500px" height="100%" :adaptive="true">
        <shareSettings @permissionChanged="checkForFlag()"></shareSettings>
      </modal>
    </transition>
  </div>
</template>

<script>
const VueMarkdown = () => import('vue-markdown')
const AirbnbDatePicker = () => import('@/components/AirbnbDatePicker.vue')
const IpDeviceInfo = () => import('@/components/IpDeviceInfo.vue')
const VisitorProfile = () => import('@/components/VisitorProfile.vue')
import moment from 'moment'
import { store } from '@/store'
import { mixin as clickaway } from 'vue-clickaway'
const shareSettings = () => import('@/pages/shareSetting.vue')

export default {
  mixins: [clickaway],
  props: [
    'compact',
    'embeded',
    'limit',
    'pagination',
    'widget_id',
    'poll_id',
    'impression',
  ],
  store,
  data: function () {
    return {
      summaryLoading: false,
      summary: '',
      pollName: '',
      refreshKey: 0,
      pollIdGroup: null,
      filterByText: '',
      detailKey: 0,
      selected: null,
      questionList: [],
      pollGroupId: 0,
      data: {},
      showModal: false,
      modalSrc: '',
      modalCaption: '',
      page: 0,
      hasNext: true,
      isLoaded: false,
      showMore: null,
      isOpenendQuestion: false,
      showOtherOnly: false,
      isNps: false,
      visitor_id: 0,
      getPoll: [],
      pollAnswerCounter: {},
      showNps: {
        promoter: true,
        passive: true,
        detractor: true,
      },
      nps: {
        range: 0,
        promoter: 0,
        passive: 0,
        detractor: 0,
        score: 0,
      },
      myColors: ['#1f77b4', '#629fc9', '#94bedb', '#c9e0ef'],
      defaultWords: [],
      tempWidgetId:0,
      tempjwt:'',
      secretPosition:17,
      isShareSession:false,
      isPublicShare:false,
      isAdminRole : this.$session.get('role') !== 3 && this.$session.get('role') !== 2,
      allData: {}
    }
  },
  components: {
    VueMarkdown,
    AirbnbDatePicker,
    IpDeviceInfo,
    VisitorProfile,
    wordcloud: () => import('vue-wordcloud'),
    shareSettings
  },
  beforeMount() {
    this.assignValuesForShare()
    if (!this.$route.params.pollGroupId)
      this.$router.push({ path: '/feedback' })
    this.pollGroupId = this.$route.params.pollGroupId
    console.log(this.pollGroupId)
  },
  mounted() {
    this.init()
    this.$auditlog({ module: 'usage', action: 'view_survey' })  
    
    try{
      howuku.track('usage', { feature: 'view_survey' })
    }catch(e){}

    try{
      _cio.track('usage', { feature: 'view_survey', created_at: Math.round(new Date().getTime() / 1000) })
    }catch(e){}             
  },
  watch: {
    selected(id) {
      for (let i in this.data.poll) {
        if (this.data.poll[i].poll_id === id) {
          this.getPoll = this.data.poll[i]
          this.getPollComment(this.data.poll[i])
          break
        }
      }
    },
    '$store.getters.datepicker.dashboard': {
      handler: function (date) {
        this.startDate = date.startDate
        this.endDate = date.endDate
        this.getPollComment(this.getPoll)
        this.init()
      },
      deep: true,
    },
    '$store.getters.widget_id' : {
      handler:function(){
        if(!this.isShareSession){
          this.$router.push({ path: '/survey' })
        }
      },
      deep: true,
    }
    // '$store.getters.faces': {
    //   handler: function (value) {
    //     this.init()
    //   },
    // },
  },
  methods: {
    getData(){
      this.getPollComment(this.getPoll)
    },
    goBack() {
      this.$router.push({ path: '/survey' })
    },
    // downloadPdf() {
    //   if (
    //     this.$isFreePlan.includes(this.$session.get('paid_plan')) ||
    //     this.$isLegacyFreePlan.includes(this.$session.get('paid_plan'))
    //   ) {
    //     this.$swal.fire({
    //       title: 'Upgrade your plan',
    //       text: 'This is a paid feature. Upgrade your plan to access more features.',
    //       type: 'warning',
    //       confirmButtonColor: '#2167f5',
    //     })
    //     return
    //   }
    //   var jsPDF = require('jspdf')
    //   var html2canvas = require('html2canvas')
    //   var listing = document.getElementsByClassName('listing')
    //   var btn = document.getElementsByClassName('listing')
    //   var scrollable = document.getElementsByClassName('scrollable')

    //   for (let i = 0; i < listing.length; i++) {
    //     listing[i].classList.add('noshadow')
    //   }

    //   for (let i = 0; i < btn.length; i++) {
    //     btn[i].classList.add('noshadow')
    //   }

    //   for (let i = 0; i < scrollable.length; i++) {
    //     scrollable[i].classList.remove('scrollable')
    //   }
    //   var offScreen =
    //     document.getElementsByClassName('container-fluid')[0].children[0]
    //   // var offScreen = document.getElementById('content-data')

    //   html2canvas(offScreen, {
    //     logging: true,
    //     useCORS: true,
    //     letterRendering: 1,
    //     allowTaint: false,
    //     scale: 1,
    //     // onrendered: function (canvas) {
    //     //   document.body.appendChild(canvas)
    //     //   document.body.removeChild(clone)
    //     // },
    //   }).then(function (canvas) {
    //     var imgData = canvas.toDataURL('image/png')
    //     var imgWidth = 210
    //     var pageHeight = 295
    //     var imgHeight = (canvas.height * imgWidth) / canvas.width
    //     var heightLeft = imgHeight
    //     var doc = new jsPDF('p', 'mm')
    //     var position = 10 // give some top padding to first page

    //     doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
    //     heightLeft -= pageHeight

    //     while (heightLeft >= 0) {
    //       position = heightLeft - imgHeight // top padding for other pages
    //       doc.addPage()
    //       doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
    //       heightLeft -= pageHeight
    //     }
    //     doc.save('polls_report.pdf')

    //     for (let i = 0; i < listing.length; i++) {
    //       listing[i].classList.remove('noshadow')
    //     }

    //     for (let i = 0; i < btn.length; i++) {
    //       btn[i].classList.remove('noshadow')
    //     }

    //     for (let i = 0; i < scrollable.length; i++) {
    //       scrollable[i].classList.add('scrollable')
    //     }
    //   })
    // },
    async summarize() {
      if (this.summary === '') {

        if (this.$isFreePlan.includes(this.$session.get('paid_plan'))) {
          let limitCounter = await this.$findAuditlog({
            module: 'ai-usage',
            action: 'survey',
            company_id: this.$session.get('company_id')
          })

          if (limitCounter.length > 5) {
            this.$swal.fire({
              title: 'Upgrade your plan',
              text: 'This is a paid feature. You need to upgrade your account to gain unlimited access to Howuku AI.',
              type: 'warning',
              confirmButtonColor: '#2167f5'
            })      

            this.$auditlog({
              module: 'paywall',
              action: 'survey-ai',
              description: 'poll_group_id: ' + this.pollIdGroup
            })

            return
          }
        }

        this.$auditlog({
          module: 'ai-usage',
          action: 'survey',
          description: 'poll_group_id: ' + this.pollIdGroup
        })

        this.summaryLoading = true
        this.$http
        .post(process.env.API_ENDPOINT + '/poll/comment/summarize', {
          poll_id: this.pollIdGroup,
          start_date: this.$store.getters.datepicker.dashboard.startDate,
          end_date: this.$store.getters.datepicker.dashboard.endDate,
        },{
          headers: {
          'jwt': this.tempjwt
         }
        })
        .then((result) => {
          console.log(result)
          this.summary = result.data
          this.summaryLoading = false
        })
      }
      this.$modal.show('show-survey-summary')
    },
    exportCsv() {
      if (
        this.$isFreePlan.includes(this.$session.get('paid_plan')) ||
        this.$isLegacyFreePlan.includes(this.$session.get('paid_plan'))
      ) {
        this.$swal.fire({
          title: 'Upgrade your plan',
          text: 'This is a paid feature. Upgrade your plan to access more features.',
          type: 'warning',
          confirmButtonColor: '#2167f5',
        })
        return
      }

      this.$http
        .post(process.env.API_ENDPOINT + '/poll/comment/group', {
          poll_id: this.pollIdGroup,
          start_date: this.$store.getters.datepicker.dashboard.startDate,
          end_date: this.$store.getters.datepicker.dashboard.endDate,
        },{
          headers: {
          'jwt': this.tempjwt
         }
        })
        .then((result) => {
          let data = result.data

          var csv = []
          if (!data.length) {
            this.$swal.fire({
              title: 'Opps..',
              text: "You don't have any data to export.",
              type: 'error',
              confirmButtonColor: '#2167f5',
            })
            return
          }
          let column = [
            '"Date"',
            '"Session"',
            '"Email"',
            '"Recording"',
            '"Page"',
          ]

          for (let i = 0; i < this.data.poll.length; i++) {
            column.push('"' + this.data.poll[i].poll_question + '"')
          }
       
          csv.push('sep=;')
          csv.push(column.join(';'))
          let row = []

          for (let i in data) {
            let row = []
            row.push(
              '"' +
                moment(data[i].created_at).format('YYYY-MM-DD hh:mm a') +
                '"'
            )
            row.push('"' + data[i].session + '"')
            row.push('"' + data[i].email + '"')
            if (data[i].has_recording) {
              row.push(
                '"https://app.howuku.com/video/' + data[i].has_recording + '"'
              )
            } else {
              row.push('""')
            }
            row.push('"' + data[i].destination + '"')
            row.push('"' + data[i].poll_answer_1 + '"')

            for (let j = 2; j < this.pollIdGroup.length; j++) {
              if (data[i]['poll_answer_' + j]) {
                row.push('"' + data[i]['poll_answer_' + j] + '"')
              } else {
                row.push('""')
              }
            }

            csv.push(row.join(';'))
          }
          var csv_string = csv.join('\n')
          var filename = 1 + '_' + new Date().toLocaleDateString() + '.csv'
          var link = document.createElement('a')
          link.style.display = 'none'
          link.setAttribute('target', '_blank')
          link.setAttribute(
            'href',
            'data:text/csv;charset=utf-8,' + encodeURIComponent(csv_string)
          )
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
    },
    findMatchingKeyword(x) {
      return x
        .toLowerCase()
        .split(' ')
        .includes(this.filterByText.toLowerCase())
    },
    showProfile(x) {
      this.visitor_id = x
      this.$modal.show('show-profile')
    },
    parentEdit() {
      this.$emit('callback', {
        widget_id: (!this.isShareSession) ? this.$session.get('widget_id') : this.tempWidgetId ,
        poll_group_id: this.pollGroupId,
      })
    },
    hideMenu() {
      this.showMore = null
    },
    init: function () {
      this.isLoaded = false
      this.getComments()
    },
    inAnswerList(comment) {
      if (this.data.answerList.includes(comment)) {
        return false
      }
      return true
    },
    wordClickHandler(name, value, vm) {
      this.filterByText = name
    },
    concealOldPost(dt) {
      let current = +moment(dt)
      let sevendaysago = +moment().add(-7, 'day')
      let value = current < sevendaysago
      return value && this.$isFreePlan.includes(this.$session.get('paid_plan')) &&!this.isShareSession
    },
    checkifOther: function (item) {
      return item.comment_body !== ''
    },
    checkifNps(item) {
      if (Number(item.answer) >= 9 && this.showNps.promoter) return true
      if (
        (Number(item.answer) === 7 || Number(item.answer) === 8) &&
        this.showNps.passive
      )
        return true
      if (Number(item.answer) <= 6 && this.showNps.detractor) return true
      return false
    },
    processWordCloud(text) {
      if (typeof text !== 'string') return
      let words = text.split(' ')

      for (let i in words) {
        let found = false
        for (let j in this.defaultWords) {
          if (this.defaultWords[j].name === words[i]) {
            this.defaultWords[j].value++
            found = true
            break
          }
        }
        if (!found) {
          this.defaultWords.push({
            name: words[i],
            value: 0,
          })
        }
      }
    },
    getPollComment(poll) {
      this.isLoaded = false
      this.isOpenendQuestion = poll.poll_option_openend
      this.pollAnswerCounter = {}
      this.allData = {}
      
      this.$http
        .post(process.env.API_ENDPOINT + '/poll/comments2', {
          widget_id: (!this.isShareSession) ? this.$session.get('widget_id') : this.tempWidgetId,
          poll_id: poll.poll_id
        },{
          headers: {
            'jwt': this.tempjwt
          }
        })
        .then((response2) => {
          this.allData.comment = response2.data
          console.log('/poll/comments2')
          console.log(this.allData.comment)
          console.log(this.allData.comment.length)
          console.log('filter')
          console.log(this.allData.comment.filter(a => a.answer === 'Volautomaat'))
          console.log(this.allData.comment.filter(a => a.answer === 'Volautomaat').length)
        
          this.$http
            .post(process.env.API_ENDPOINT + '/poll/comments', {
              widget_id: (!this.isShareSession) ? this.$session.get('widget_id') : this.tempWidgetId,
              poll_id: poll.poll_id,
              start_date: this.$store.getters.datepicker.dashboard.startDate,
              end_date: this.$store.getters.datepicker.dashboard.endDate,
            },{
              headers: {
                'jwt': this.tempjwt
              }
            })
            .then((response) => {

              this.data.pollTotal = 0
              this.data.answerList = []
              this.data.answer = []
              this.data.answerList = poll.poll_answer
                ? poll.poll_answer.split('@@@@@')
                : []
              let pollAnswer = poll.poll_answer
                ? poll.poll_answer.split('@@@@@')
                : []
              let pollAnswerId = poll.poll_answer_id
                ? poll.poll_answer_id.split('@@@@@')
                : []

              let totalResponse = poll.poll_answer_count
                ? poll.poll_answer_count.split('@@@@@')
                : []
              for (let i = 0; i < pollAnswer.length; i++) {
                /*
         calculatePercent(
                      answer.count
                        ? answer.count
                        : pollAnswerCounter[answer.id],
                      data.pollTotal
                    ) *                
                */
                this.data.answer.push({
                  id: pollAnswerId[i],
                  text: pollAnswer[i],
                  count: totalResponse[i],
                })
              }
              this.data.comment = response.data
              console.log('/poll/comments')
              console.log(this.data.comment)
              console.log(this.data.comment.length)
              console.log('filter')
              console.log(this.data.comment.filter(a => a.answer === 'Volautomaat'))
              console.log(this.data.comment.filter(a => a.answer === 'Volautomaat').length)
              
              // this.data.pollTotal = poll.poll_answer_count
              //   ? poll.poll_answer_count
              //     .split('@@@@@')
              //     .reduce((a, b) => Number(a) + Number(b), 0)
              //   : response.data.length
              this.data.otherAnswerCount = this.data.pollTotal - 0 // nonOtherAnswerCount
              this.isNps = poll.poll_option_nps

              // For NPS
              if (this.isNps) {
                this.nps.total = 0
                this.nps.promoter = 0
                this.nps.passive = 0
                this.nps.detractor = 0
                this.nps.score = 0
                this.pollAnswerCounter = {}
                // this.defaultWords = []

                if (response.data.length) {
                  for (let i = 0; i < response.data.length; i++) {
                    let data = response.data[i]
                    if (this.isNps) {
                      let nps_calc = Math.round(
                        (100 * Number(data.answer)) / Number(this.nps.range),
                        0
                      )

                      if (nps_calc >= 80) this.nps.promoter++
                      if (nps_calc >= 70 && nps_calc < 80) this.nps.passive++
                      if (nps_calc <= 60) this.nps.detractor++
                      this.nps.total =
                        this.nps.promoter + this.nps.passive + this.nps.detractor
                    }
                  }
                }

                if (this.isNps && this.nps.total) {
                  this.nps.score = Math.round(
                    ((this.nps.promoter - this.nps.detractor) / this.nps.total) *
                      100,
                    0
                  )
                  this.nps.promoter = (this.nps.promoter / this.nps.total) * 100
                  this.nps.passive = (this.nps.passive / this.nps.total) * 100
                  this.nps.detractor = (this.nps.detractor / this.nps.total) * 100
                }
              }
              //

              for (let i = 0; i < response.data.length; i++) {
                let data = response.data[i]

                if (this.pollAnswerCounter[data.poll_answer_id])
                  this.pollAnswerCounter[data.poll_answer_id]++
                else this.pollAnswerCounter[data.poll_answer_id] = 1
                this.processWordCloud(data.comment_body)
              }

              this.data.pollTotal = 0
              for (let i = 0; i < pollAnswer.length; i++) {
                this.data.pollTotal += Number(this.pollAnswerCounter[pollAnswerId[i]])
              }
              this.detailKey++
              this.isLoaded = true
            })
        })
        .catch((err) => {
          console.log('error')
          console.error(err)
        })
      setTimeout(() => {
        this.refreshKey++
      }, 100)
    },
    getComments: function () {
      console.log('getComments')
      this.$http
        .post(process.env.API_ENDPOINT + '/getPolls2', {
          widget_id: (!this.isShareSession) ? this.$session.get('widget_id') : this.tempWidgetId,
          poll_group_id: this.pollGroupId,
        },{
          headers: {
          'jwt': this.tempjwt
         }
        })
        .then((response) => {
          let data = response.data.filter(
            (item) => item.poll_option_openend !== 4
          )
          let seq = data[0].sequence.split(',')
          this.pollIdGroup = data[0].sequence
          this.data.poll = []

          console.log(seq[0])

          if (seq.length) {
            console.log('getComments2')
            for (let i = 0; i < seq.length; i++) {
              for (let j = 0; j < data.length; j++) {
                console.log(data[j].poll_id + ' = ' + seq[i])
                if (Number(data[j].poll_id) === Number(seq[i])) {
                  this.data.poll.push(data[j])
                  console.log('push ' + data[j])
                }

                if (data[j].impression)
                  this.data.impression = data[j].impression
              }
            }
            this.selected = this.data.poll[0].poll_id
            this.pollName = this.data.poll[0].name
          }
          this.data.impression = this.data.poll[0].impression
          // this.getPollComment(this.data.poll[0])
          this.selected = this.data.poll[0].poll_id

          let json = JSON.parse(this.data.poll[0].extra)
          if (json.npsRange) this.nps.range = json.npsRange
        })
    },
    loadMore: function (page) {
      if (!this.pagination) this.pagination = 10
      this.page += 1

      let pagi = this.paginator(this.fulldata, 1, this.pagination * this.page)
      this.hasNext = pagi.nextPages
      this.data = pagi.data
    },
    deleteDescription(id) {
      this.$swal
        .fire({
          title: 'Are you sure?',
          text: "There are no going back once it's done!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'rgb(255, 75, 57)',
          cancelButtonColor: '#dcdcdc',
          confirmButtonText: 'Yes, delete it!',
        })
        .then((result) => {
          if (result.value) {
            this.$http
              .post(process.env.API_ENDPOINT + '/comment/delete', {
                comment_id: id,
              })
              .then(() => {
                document.getElementById(id).remove()
              })
            this.$swal.fire({
              title: 'Deleted!',
              text: 'Your recording has been deleted.',
              type: 'success',
              confirmButtonColor: '#2167f5',
            })
          }
        })
    },
    shorten(string, len) {
      if (!string) return string

      if (string.length > len) return string.substring(0, len) + '...'
      else return string
    },
    shorten_last(string, len) {
      if (!string) return string

      if (string.length > len) return string.substring(-10, len)
      else return string
    },
    precisionRound: function (number, precision) {
      var factor = Math.pow(10, precision)
      return Math.round(number * factor) / factor
    },
    showImage: function (src, caption) {
      if (src) {
        this.modalSrc = src
        this.modalCaption = caption
        this.showModal = true
      }
    },
    paginator: function (items, page, perPage) {
      var offset = 0
      var paginatedItems = items.slice(offset).slice(0, perPage)
      var totalPages = Math.ceil(items.length / perPage)

      perPage = perPage || 10

      return {
        page: page,
        perPage: perPage,
        pre_page: page - 1 ? page - 1 : null,
        nextPages: totalPages > page ? page + 1 : null,
        total: items.length,
        totalPages: totalPages,
        data: paginatedItems,
      }
    },
    hideModal: function () {
      this.showModal = false
    },
    getImgSrc: function (key) {
      return key
        ? 'https://api.mida.so/image/' +
            this.$session.get('company_id') +
            '/' +
            key
        : null
    },
    getFaceValue: function (rank) {
      let name = ''
      switch (rank) {
        case 1:
          name = 'https://cdn.howuku.com/images/veryhappy.png'
          break
        case 2:
          name = 'https://cdn.howuku.com/images/happy.png'
          break
        case 3:
          name = 'https://cdn.howuku.com/images/sad.png'
          break
        case 4:
          name = 'https://cdn.howuku.com/images/verysad.png'
          break
      }
      return name
    },
    calculatePercent: function (a, b) {
      let number = this.precisionRound((a / b) * 100, 2)
      if (!number) number = 0
      return number
    },
    timeSince: function (time, lang) {
      return moment(time).fromNow()
    },
    openShareLinkSettings(){
      this.$modal.show('show-shareSettings')
    },
    assignValuesForShare(){
      if(!this.$route.params.encryptedParam){
        this.tempjwt = localStorage.getItem('jwt')
        this.tempWidgetId = this.$session.get('widget_id')
        this.checkForFlag()
      }else{
        //if is not share session then assign 
        this.isShareSession = true
        this.tempjwt = window.TEMP_JWT
        this.tempWidgetId = window.TEMP_WIDGET_ID
        this.$store.commit('setDatepicker', {
          module: 'dashboard',
          name: 'startDate',
          data: window.TEMP_START_DATE
        })
        this.$store.commit('setDatepicker', {
          module: 'dashboard',
          name: 'endDate',
          data: window.TEMP_END_DATE
        })
      }
    },
    checkForFlag(){
        this.$http.get(process.env.API_ENDPOINT + '/sharePermission',{
            headers:{
            'company_id':this.$session.get('company_id'),
            'widget_id':this.$session.get('widget_id')
            }
        }).then(result =>{
            for (let index = 0; index < result.data.length; index++) {
                const element = result.data[index];
                if(element.modules === this.$route.name && element.unique_module_id === parseInt(this.$route.params.pollGroupId)){
                    this.isPublicShare = (element.flag===0) ? true:false
                }
            }
        })
    },
  },
}
</script>
<style>
.poll-promoter {
  background-color: #28eb1430;
  border-radius: 4px;
  height: 100%;
  position: absolute;
}

.poll-passive {
  background-color: #ffca0130;
  border-radius: 4px;
  height: 100%;
  position: absolute;
}

.poll-detractor {
  background-color: #ff000030;
  border-radius: 4px;
  height: 100%;
  position: absolute;
}

.screenshot-image {
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.2), 0 2 205 0 rgba(0, 0, 0, 0.19);
  max-height: 200px;
  max-width: 50%;
}

.single-col {
  width: 60px !important;
}

.last-col {
  width: 150px !important;
}

.angryrow {
  background-color: rgba(255, 0, 0, 0.07);
}

.howu-comment tr:hover {
  /* background-color: rgba(0, 0, 0, 0.02); */
  border-radius: 12px;
}

.howu-comment tr.hasAttachment:hover {
  /* background-color: rgba(147, 177, 12, 0.02); */
  cursor: pointer;
  border-radius: 12px;
}

/* .thumbnail {
  margin: 20px 0;
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 3px 0 rgba(0, 0, 0, 0.19);
}

.thumbnail img {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 100%;
  width: auto;
  -webkit-transform: translate(-50%,-50%);
      -ms-transform: translate(-50%,-50%);
          transform: translate(-50%,-50%);
}
.thumbnail img.portrait {
  width: 100%;
  height: auto;
}
*/

.faces {
  width: 50px;
  vertical-align: center;
  position: absolute;
}

/* modal css */
#myImg {
  border-radius: 4px;
  cursor: pointer;
  transition: 0.3s;
}

#myImg:hover {
  opacity: 0.7;
}

/* The Modal (background) */
.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 100; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
}

/* Modal Content (Image) */
.modal-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Caption of Modal Image (Image Text) - Same Width as the Image */
#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}

/* Add Animation - Zoom in the Modal */
.modal-content,
#caption {
  animation-name: zoom;
  animation-duration: 0.6s;
}
.listing {
  margin: 20px 0px;
}
@keyframes zoom {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

/* The Close Button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

.comment-row {
  padding: 10px;
}

.comment-speech {
  background-color: #00000007;
  color: #000000;
  border-radius: 12px;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 20px;
  padding-right: 20px;
  font-weight: 500;
  margin-left: 60px;
  margin-right: auto;
}

.hasContact {
  background-color: rgba(239, 251, 187, 0.502);
}

.comment-body {
  font-size: 16px;
}

.comment-row {
  border-bottom: 1px dashed #dedede;
  padding: 10px 5px;
}

.basic-info {
  margin-left: 60px;
}

.commenter {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular',
    sans-serif;
  font-weight: 600;
}

.side-filter {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);

  border: 1px solid #dddfe2;
  position: fixed;
  min-width: 300px;
  padding: 10px 10px;
}

.fixed {
  position: fixed;
}

.textbox-icon {
  float: right;
  margin-right: 10px;
  margin-top: -28px;
  position: relative;
  z-index: 2;
  color: #aaaaaa;
}

.not-full {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  padding-left: 1rem;
  padding-right: 2rem;
}

div.trim-comment {
  max-height: 300px;
  overflow: hidden;
  cursor: pointer;
}

.dropdown-comment-menu {
  position: absolute;
  background-color: var(--background);
  min-width: 220px;
  right: 30px;
  margin-top: 5px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 2px 0;
  text-align: left;
  z-index: 2000;
}

.dropdown-comment-menu span {
  color: var(--color);
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  cursor: default;
}

.dropdown-comment-menu span:hover {
  background-color: #0068cf1e;
}

.dropdown-comment-menu > hr {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
}
[data-title]:hover:after {
  background: rgb(255, 53, 53) !important;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  top: 20px;
  color: #fff;
  content: attr(data-title);
  left: 10px;
  padding: 5px 8px;
  position: absolute;
  z-index: 9999;
  text-align: left !important;
  width: 500px;
  font-size: 14px;
}
.dropdown-divider {
  background-color: #dbdbdb;
  border: none;
  display: block;
  height: 1px;
  margin: 0.5rem 0;
}

.howu-tag-review {
  padding: 10px;
}

.blockInteraction {
  pointer-events: none;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-content {
    width: 100%;
  }

  img.mobile-view {
    display: none;
  }

  div.mobile-view {
    margin-left: 0px;
  }
}

.progress-bar-success-fade {
  background-color: rgba(92, 184, 92, 0.5) !important;
}
.progress-bar-danger-fade {
  background-color: rgba(217, 83, 79, 0.5) !important;
}
.progress-bar-warning-fade {
  background-color: rgba(240, 173, 78, 0.5) !important;
}

.progress-bar-success {
  background-color: #5cb85c !important;
}
.progress-bar-danger {
  background-color: #d9534f !important;
}
.progress-bar-warning {
  background-color: #f0ad4e !important;
}

.progress-square {
  border-radius: 0px !important;
  height: 40px;
}

g text {
  cursor: pointer;
}

.md-preview h2 {
  font-size: 16px;
  margin-top: 40px;
  margin-bottom: 10px;
  font-weight: 800;
}

.md-preview p {
  padding-left: 1em;
}

.md-preview ul {
  padding-left: 1.5em;
}

</style>



// WEBPACK FOOTER //
// src/components/PollDetails.vue